// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__xyJMO","selects":"Documents_selects__6kksf"};